/*
 * action types
 */

export const NotificationActions = {
    NEW_NOTIFICATION: 'NEW_NOTIFICATION',
    CLEAR_SINGLE_NOTIFICATION : 'CLEAR_SINGLE_NOTIFICATION',
    CLEAR_NOTIFICATIONS: 'CLEAR_NOTIFICATIONS'
}

export const DomainActions = {
  SET_DOMAINS_LIST: 'SET_DOMAINS_LIST',
  CLEAR_DOMAINS_LIST: 'CLEAR_DOMAINS_LIST'
}

export const AppStateActions = {
  SET_LOADING_TRUE: 'SET_LOADING_TRUE',
  SET_LOADING_FALSE: 'SET_LOADING_FALSE',
  SET_LOGGED_IN_USER: 'SET_LOGGED_IN_USER',
  SET_SERVER_CLIENT_TIMEOFFSET: 'SET_SERVER_CLIENT_TIMEOFFSET'
}

export const LeaderboardActions = {
  SET_LEADERBOARD_LIST: 'SET_LEADERBOARD_LIST',
  CLEAR_LEADERBOARD_LIST: 'CLEAR_LEADERBOARD_LIST'
}

export const BadgeActions = {
  SET_BADGES: 'SET_BADGES'
}

/*
 * action creators
 */

export function addNotification(notification) {
  return { type: NotificationActions.NEW_NOTIFICATION, payload: notification }
}

export function clearAllNotifications() {
  return { type: NotificationActions.CLEAR_NOTIFICATIONS }
}

export function clearSingleNotification(notificationId) {
  return { type: NotificationActions.CLEAR_SINGLE_NOTIFICATION, payload: notificationId }
}

export function setDomainsList(listOfDomains){
  return { type: DomainActions.SET_DOMAINS_LIST, payload: listOfDomains }
}

export function clearDomainsList(){
  return { type: DomainActions.SET_DOMAINS_LIST }
}

export function setLeaderboardsList(listOfLeaderboards){
  return { type: LeaderboardActions.SET_LEADERBOARD_LIST, payload: listOfLeaderboards }
}

export function clearLeaderboardsList(){
  return { type: LeaderboardActions.SET_LEADERBOARD_LIST }
}

export function setLoadingToTrue(){
  return { type: AppStateActions.SET_LOADING_TRUE }
}

export function setLoadingToFalse(){
  return { type: AppStateActions.SET_LOADING_FALSE }
}

export function setLoggedInUser(alias){
  return { type: AppStateActions.SET_LOGGED_IN_USER, payload: alias }
}

export function setServerClientTimeOffset(value){
  return { type: AppStateActions.SET_SERVER_CLIENT_TIMEOFFSET, payload: value }
}

export function setBadges(listOfBadges){
  return { type: BadgeActions.SET_BADGES, payload: listOfBadges }
}


// WEBPACK FOOTER //
// ./src/app/res/actions.js